<div class="w-full h-full flex flex-row">
    <div #mapContainer class="w-full h-full"></div>
    <div class="w-1/4 h-[calc(100vh-12rem)] flex flex-col min-h-0 bg-white border-l border-slate-200">
        <div class="px-4 py-3 border-b border-slate-200">
            <div class="text-base font-semibold text-slate-800 tracking-wide uppercase">
                {{'Vehicles' | translate}}
            </div>
            <div class="text-xs text-slate-400 mt-0.5">{{filteredVehicles.length}} /
                {{vehiclePositionAndDrivers.length}} {{'total' | translate}}</div>
            <div class="mt-2 relative">
                <mat-icon
                    class="!text-base !w-4 !h-4 absolute left-2 top-1/2 -translate-y-1/2 text-slate-400">search</mat-icon>
                <input type="text" [(ngModel)]="searchFilter" placeholder="{{'Search plate or VIN...' | translate}}"
                    class="w-full pl-7 pr-7 py-1.5 text-xs border border-slate-200 rounded focus:outline-none focus:border-tachosafe-500 focus:ring-1 focus:ring-tachosafe-500">
                <button *ngIf="searchFilter" (click)="searchFilter = ''"
                    class="absolute right-1.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                    <mat-icon class="!text-base !w-4 !h-4">close</mat-icon>
                </button>
            </div>
        </div>
        <div class="flex flex-col overflow-y-auto flex-1 min-h-0">
            <!-- Skeleton loading -->
            <ng-container *ngIf="loading && vehiclePositionAndDrivers.length === 0">
                <div *ngFor="let _ of [1,2,3,4,5,6]" class="px-3 py-2 border-b border-slate-100 animate-pulse">
                    <div class="flex items-center justify-between gap-2">
                        <span class="inline-flex items-center gap-1.5">
                            <span class="w-2 h-2 rounded-full bg-slate-200"></span>
                            <span class="h-6 w-20 rounded bg-slate-200"></span>
                        </span>
                        <span class="w-7 h-7 rounded-full bg-slate-200"></span>
                    </div>
                    <div class="h-3 w-40 bg-slate-200 rounded mt-1"></div>
                    <div class="h-3 w-48 bg-slate-200 rounded mt-1"></div>
                    <div class="h-3 w-16 bg-slate-200 rounded mt-1"></div>
                    <div class="h-3 w-32 bg-slate-200 rounded mt-1"></div>
                </div>
            </ng-container>
            <!-- Vehicle cards -->
            <div *ngFor="let pos of filteredVehicles; let i = index"
                class="group px-3 py-2.5 border-b border-slate-100 hover:bg-slate-50 transition-colors duration-150 cursor-default space-y-1.5">
                <div class="flex items-center justify-between gap-2">
                    <span class="inline-flex items-center gap-1.5 min-w-0">
                        <span class="w-2 h-2 rounded-full flex-shrink-0"
                            [ngClass]="isRecent(pos) ? 'bg-green-500' : 'bg-gray-400'"
                            [matTooltip]="isRecent(pos) ? ('Up to date' | translate) : ('Outdated' | translate)"></span>
                        <span
                            class="inline-flex items-center px-2 py-0.5 rounded text-sm font-bold bg-tachosafe-500 text-white tracking-wide"
                            [matTooltip]="pos.lastPositionTime ? ('Last seen' | translate) + ': ' + (pos.lastPositionTime | date:'yyyy-MM-dd HH:mm:ss') : null">
                            {{pos.registrationNumber}}
                        </span>
                    </span>
                    <button *ngIf="!(pos.lat==0 && pos.lng==0)"
                        class="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center hover:bg-tachosafe-500 hover:text-white text-tachosafe-500 transition-colors duration-150"
                        (click)="onClickShowOnMap(pos)" matTooltip="{{'Show on map' | translate}}">
                        <mat-icon class="!text-lg !w-4.5 !h-4.5 !leading-4.5">my_location</mat-icon>
                    </button>
                </div>
                <div class="text-xs text-slate-400 font-mono truncate">{{pos.vin || '—'}}</div>
                <div class="flex items-center gap-1">
                    <mat-icon
                        class="!text-[14px] !w-[14px] !h-[14px] !leading-[14px] text-slate-400 flex-shrink-0">location_on</mat-icon>
                    <span class="text-xs text-slate-500 line-clamp-2"
                        [matTooltip]="pos.address && pos.address.length > 60 ? pos.address : null">{{pos.address ||
                        '—'}}</span>
                </div>
                <div class="flex items-center gap-1">
                    <mat-icon class="!text-[14px] !w-[14px] !h-[14px] !leading-[14px]"
                        [ngClass]="pos.speed > 0 ? 'text-green-600' : 'text-slate-300'">speed</mat-icon>
                    <span class="text-xs font-medium"
                        [ngClass]="pos.speed > 0 ? 'text-green-600' : 'text-slate-300'">{{pos.speed > 0 ?
                        pos.speed.toFixed(0) + ' km/h' : '—'}}</span>
                </div>
            </div>
            <div *ngIf="filteredVehicles.length === 0"
                class="flex flex-col items-center justify-center py-12 text-slate-400">
                <mat-icon class="!text-4xl mb-2">directions_car</mat-icon>
                <span class="text-sm">{{'No vehicles found' | translate}}</span>
            </div>
        </div>
    </div>
</div>